import script from "./MemberAssets.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberAssets.vue?vue&type=script&setup=true&lang=js"

import "./MemberAssets.vue?vue&type=style&index=0&id=64f56105&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64f56105"]])

export default __exports__